import React, { useState, useRef, useEffect } from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
// import { InstantSearch } from "react-instantsearch";
const InstantSearch = dynamic(() =>
  import("react-instantsearch").then((mod) => mod.InstantSearch)
);
const CustomSearchBox = dynamic(
  () => import("components/ui/search/CustomSearchBox/CustomSearchBox")
);

import { initSearch } from "../../../lib/algolia.js";

// pages/index.js

const PageLoader = dynamic(
  () => import("components/ui/loaders/PageLoader/PageLoader"),
  { ssr: false }
);

const InfiniteHits = dynamic(
  () => import("components/ui/search/InfiniteHits/InfiniteHits")
);
const EmptyQueryBoundary = dynamic(
  () => import("components/ui/search/EmptyQueryBoundary/EmptyQueryBoundary"),
  { loading: () => <PageLoader /> }
);
const EmptyQuery = dynamic(() => import("./EmptyQuery"));

// import { history } from "instantsearch.js/es/lib/routers/index.js";// pages/index.js

const Button = dynamic(() => import("components/ui/buttons/Button/Button"));

// const ExperienceSidebar = dynamic(() => import("./ExperienceSidebar"), {
//   loading: () => <PageLoader />,
// });
import ExperienceSidebar from "./ExperienceSidebar";

import useWindowSize from "/lib/hooks/useWindowSize";

import styles from "./ExperienceList.module.scss";

const searchClient = initSearch();

const ExperienceList = ({ serverState, url, currency }) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const h1Ref = useRef();

  const windowSize = useWindowSize();

  const closeFilterMenu = () => {
    setIsFilterOpen(() => false);
    const body = document.querySelector("body");
    body.classList.remove(`${styles.noScroll}`);
  };

  const filterButtonRef = useRef(null);
  // const filterMenuRef = useOutsideClick(closeFilterMenu, [filterButtonRef]);

  const handleFilterButtonClick = (event) => {
    setIsFilterOpen(() => !isFilterOpen);
    const body = document.querySelector("body");
    body.classList.toggle(`${styles.noScroll}`);
  };

  let timerId = null;

  // Debounce Algolia searches
  function queryHook(query, search) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => search(query), 200);
  }

  useEffect(() => {
    if (windowSize.width < 768) {
      h1Ref.current.remove();
    }
  }, [windowSize.width]);

  return (
    <div className={`${styles.experienceListContainer}`}>
      {/* <InstantSearchSSRProvider {...serverState}> */}

      {/* This h1 should appear in the "View Source" initial HTML render, but can't do that in the sidebar
       ** because InstantSearch renders client-side after load. So this h1 is shown by default and removed
       ** if the screen size is below 768px, when another h1 is then rendered within the ExperienceSidebar.
       ** That h1 doesn't appear in the source, but since this one is there by default, it should work for
       ** any bots that don't want to render JS (GoogleBot has rendered JS for some time now, so content
       **  missing from View Source isn't an issue there)
       */}
      <h1 className={`${styles.pageHeader}`} ref={h1Ref}>
        Advanced Search
      </h1>

      <InstantSearch
        searchClient={searchClient}
        indexName="experiences"
        // routing={{
        //   router: history({
        //     getLocation: () =>
        //       typeof window === "undefined" ? new URL(url) : window.location,
        //   }),
        // }}
      >
        <div className={`${styles.results}`}>
          <div className={`${styles.sidebar}`}>
            <ExperienceSidebar
              isFilterOpen={isFilterOpen}
              closeFilterMenu={closeFilterMenu}
              currency={currency}
              filterButtonRef={filterButtonRef}
            />
          </div>

          <div className={`${styles.hitBox} `}>
            <div className={`${styles.searchBoxContainer}`}>
              <div className={`${styles.searchBoxWrapper}`}>
                <div className={`${styles.searchBox} variable-container`}>
                  <CustomSearchBox placeholder="Search for experiences" />
                </div>
                {/* <BsSearch className={`${styles.searchIcon}`} /> */}

                {/* <SearchBox
                  className={`${styles.searchBox}`}
                  placeholder={`Search experiences`}
                  // queryHook={queryHook}
                /> */}
              </div>
              <div
                className={`${styles.sidebarButtonContainer}`}
                ref={filterButtonRef}
              >
                <Button
                  onClick={handleFilterButtonClick}
                  fill="transparent"
                  customStyles={{ height: "auto", padding: "0px" }}
                >
                  <div className={`${styles.sidebarButtonImageWrapper}`}>
                    <Image
                      src="/assets/img/icons/settings.svg"
                      alt="Filter icon"
                      width={windowSize.width >= 768 ? "30" : "25"}
                      height={windowSize.width >= 768 ? "30" : "25"}
                    />
                  </div>
                </Button>
              </div>
              {isFilterOpen && (
                <div className={`${styles.filterModal} fadeInAnimation`} />
              )}
            </div>
            <div className={`${styles.infiniteHitsWrapper}`}>
              <EmptyQueryBoundary fallback={<EmptyQuery />}>
                <InfiniteHits
                  currency={currency}
                  cardType="ExperienceLinkCard"
                  cardsPerRow={3}
                  headerFontSize="var(--font-size-md-sm"
                />
              </EmptyQueryBoundary>
            </div>
          </div>
        </div>
      </InstantSearch>
      {/* </InstantSearchSSRProvider> */}
    </div>
  );
};

export default ExperienceList;
